(function () {
  if (window.__swymSkipMultiPopupToggle) return;
  window.__swymSkipMultiPopupToggle = true;

  function waitForSwym(cb, tries) {
    tries = tries || 0;

    if (
      window._swat &&
      typeof window._swat.addToWishList === 'function' &&
      typeof window._swat.removeFromWishList === 'function'
    ) {
      cb();
      return;
    }

    if (tries > 30) {
      console.warn('[Wishlist] Swym not ready');
      return;
    }

    setTimeout(function () {
      waitForSwym(cb, tries + 1);
    }, 200);
  }

function parseWishJson(btn) {
  var raw = btn.getAttribute('data-wishjson');

  // ✅ ใช้ pData เฉพาะตอนมีค่าจริง
  if (raw && raw.trim() !== '') {
    try {
      return JSON.parse(raw);
    } catch (err) {
      console.warn('[Wishlist] Cannot parse data-wishjson', err);
    }
  }

  // ✅ fallback สำหรับหน้าที่ pData ว่าง
  var productId = btn.getAttribute('data-product-id');
  var variantId = btn.getAttribute('data-variant-id');
  var productUrl = btn.getAttribute('data-product-url');
  var productImage = btn.getAttribute('data-product-image');

  if (productUrl && productUrl.indexOf('http') !== 0) {
    productUrl = window.location.origin + productUrl;
  }

  return {
    empi: Number(productId),
    epi: Number(variantId),
    du: productUrl,
    iu: productImage || ''
  };
}

  function showSwymMessage(type, btn, wishData) {
  document.querySelectorAll('.custom-swym-toast').forEach(function (el) {
    el.remove();
  });

  var title =
    btn.getAttribute('data-product-title') ||
    document.querySelector('.product-single__title, .product__title, h1')?.textContent?.trim() ||
    'Product';

  var image = wishData.iu || '';

    if (image && image.indexOf('//') === 0) {
    image = 'https:' + image;
    }

  var toast = document.createElement('div');
  toast.className = 'custom-swym-toast custom-swym-toast--card';

  toast.innerHTML = `
    <button class="custom-swym-toast__close" type="button" aria-label="Close">×</button>

    <div class="custom-swym-toast__image">
      ${image ? `<img src="${image}" alt="">` : ''}
    </div>

    <div class="custom-swym-toast__content">
      <div class="custom-swym-toast__title">${title}</div>
      <div class="custom-swym-toast__text">
        ${type === 'remove' ? 'has been successfully updated in 1 list.' : 'has been successfully added to 1 list.'}
      </div>
    </div>
  `;

  document.body.appendChild(toast);

    function closeToast() {
    toast.classList.remove('is-visible');
    toast.classList.add('is-leaving');

    setTimeout(function () {
        toast.remove();
    }, 420);
    }

  toast.querySelector('.custom-swym-toast__close').addEventListener('click', closeToast);

  requestAnimationFrame(function () {
    toast.classList.add('is-visible');
  });

  setTimeout(closeToast, 3800);
}

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.swym-add-to-wishlist-view-product');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var wishData = parseWishJson(btn);

    if (!wishData || !wishData.epi || !wishData.du) {
      console.warn('[Wishlist] Missing wishlist data', wishData);
      return;
    }

    var isAdded =
      btn.classList.contains('swym-added') ||
      btn.classList.contains('is-added') ||
      btn.getAttribute('aria-pressed') === 'true';

    var productData = {
      epi: Number(wishData.epi),
      empi: Number(wishData.empi),
      du: wishData.du
    };

    btn.classList.add('is-loading');

    waitForSwym(function () {
      if (isAdded) {
        window._swat.removeFromWishList(productData, function (res) {
          console.log('[Wishlist] Removed without popup', res);

          btn.classList.remove('is-loading', 'swym-added', 'is-added');
          btn.setAttribute('aria-label', 'Add to Wishlist');
          btn.setAttribute('aria-pressed', 'false');

          showSwymMessage('remove', btn, wishData);
        });
      } else {
        window._swat.addToWishList(productData, function (res) {
          console.log('[Wishlist] Added without multi popup', res);

          btn.classList.remove('is-loading');
          btn.classList.add('swym-added', 'is-added');
          btn.setAttribute('aria-label', 'Added to Wishlist');
          btn.setAttribute('aria-pressed', 'true');

          showSwymMessage('add', btn, wishData);
        });
      }
    });
  }, true);
})();